<div *ngIf="checkingUpdate; else updateChecked">
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Comprobando actualizaciones...</p>
  </ngx-spinner>
</div>

<ng-template #updateChecked>
  <div *ngIf="authService.isAuthenticated() && authService.roles === 'Default'" class="unauthenticated-section">
    <div class="d-flex justify-content-center mt-4 mt-md-5">
      <div class="col-12 col-md-8 col-lg-6 text-center mt-3 mt-md-5 px-3">
        <p class="lead description-text" style="font-size: x-large;" *ngIf="!isTecalis">
          No tiene roles asignados. Por favor, contacte con su administrador de sistema.
        </p>
      </div>
    </div>
  </div>

  <div class="container-fluid" *ngIf="!authService.isAuthenticated() && !isRedirecting">
    <div class="row justify-content-center mt-4 mt-md-5">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ title }}</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <ng-container *ngIf="errorMessage; else logoutMsg">
              <p class="text-danger">{{ errorMessage }}</p>
              <button mat-raised-button color="primary" type="button" (click)="login()">
                Reintentar inicio de sesión
              </button>
            </ng-container>
            <ng-template #logoutMsg>
              <p>Has cerrado sesión correctamente.</p>
              <p>Pulse el botón para iniciar sesión de nuevo.</p>
              <button mat-raised-button color="primary" type="button" (click)="login()">
                Iniciar sesión
              </button>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</ng-template>